<template>
  <database-layout>
    <div v-if="error">
      <p class="text-red-600 font-bold mb-4">There were errors while importing the file: "{{ errorMessage }}". Please check the logs for more info.</p>
    </div>
    <div v-if="success">
      <base-heading>Successfully imported the database file. Redirecting to Database Sync...</base-heading>
    </div>
    <div v-else class="space-y-4">
      <base-input label="Encryption Key" v-model="encryptionKey" />
      <base-input type="file" label="Encrypted SQL File" ref="dbImportFile" />
      <base-button @click="submit">Import</base-button>
    </div>
  </database-layout>
</template>
<script>
import DatabaseLayout from './Layout.vue'
import Form from '../../components/Form';
export default {
  components: {
    DatabaseLayout,
    ...Form,
  },
  data() {
    return {
      encryptionKey: '',
      error: false,
      errorMessage: '',
      success: false,
    }
  },
  methods: {
    submit() {
      this.error = false;
      const formData = new FormData();
      formData.append('key', this.encryptionKey);
      formData.append('file', this.$refs.dbImportFile.$el.querySelector('input').files[0]);
      this.$CMS_POST('database.import.upload', {}, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((data) => {
        if (data.status == 'success') {
          // go to sync page
          this.success = true;
          setTimeout(() => {
            this.$inertia.visit(route('cms.database.sync'));
          }, 2000);
        } else {
          console.error(data);
          this.errorMessage = data.message;
          this.error = true;
        }
      });
    }
  }
}
</script>
